import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import AppContext from "../../context/AppContext";
import { onPageHeadSEO, scrollToTop } from "../../helper/HelperFunctions";
import MasterLayout from "../../layout/MasterLayout";

const PostDetails = () => {
  const { baseUrl } = useContext(AppContext);
  const { slug } = useParams();
  const [postLoading, setPostLoading] = useState(true);

  const [post, setSinglePost] = useState([]);

  const getSinglePostDetails = () => {
    const formData = new FormData();
    formData.append("slug", slug);
    axios
      .post(`${baseUrl}/api/guest/getSinglePost`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        console.log(resp.data);
        setSinglePost(resp.data.post);
        setPostLoading(false);
        onPageHeadSEO(
          resp.data.post.title,
          resp.data.post.description,
          resp.data.post.keywords
        );
      })
      .catch((error) => {
        console.log(error);
        setPostLoading(false);
      });
  };

  useEffect(() => {
    scrollToTop();
    setPostLoading(true);
    getSinglePostDetails();
  }, []);

  return (
    <MasterLayout>
      {/* Banner */}
      <Container
        fluid
        className="m-0 p-0 banner-image"
        style={{ backgroundImage: `url(${baseUrl}/storage/${post.image})` }}
      >
        <Container fluid className="m-0 p-0 overlay">
          <h6 className="caption poppins-semiBold ">Read about</h6>

          <h1 className={`text-light poppins-bold res-heading`}>
            <span className="txt-green">FixTech Expert 24</span>{" "}
          </h1>
        </Container>
      </Container>
      {/* What we offer you - Posts */}
      {postLoading ? (
        <div style={{ height: "30vh", width: "100%" }}>
          <Spinner
            size="sm"
            color="#000"
            style={{ marginLeft: "50%", marginTop: "5%" }}
          />
        </div>
      ) : (
        <Container fluid className="m-0 my-2 py-5">
          <Row className="m-0 px-5">
            <Col md={8} sm={12}>
              <img
                style={{ objectFit: "cover", height: "400px", width: "100%" }}
                src={`${baseUrl}/storage/${post.image}`}
                alt="Car Image"
              />
              <h1 className="poppins-semiBold res-headind txt-green">
                {post.title}
              </h1>
              <p className="poppins-bold res-tiny-text txt-black">
                {post.description}
              </p>
            </Col>
            <Col md={4} sm={12}>
              <Card>
                <Card.Header>
                  <Card.Title>Trending Topics Around You</Card.Title>
                  <Card.Title>{post.keywords}</Card.Title>
                </Card.Header>
                <Card.Body>
                  <h3 className="poppins-bold">
                    {post.keywords.split(",").map((keyword) => {
                      return (
                        <Badge pill bg="secondary" className="m-1">
                          {keyword}
                        </Badge>
                      );
                    })}
                  </h3>
                </Card.Body>
              </Card>
              <Card className="mt-5">
                <Card.Header>
                  <Card.Title>Want to book discounted taxi?</Card.Title>
                  <Card.Title>{post.keywords}</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Link
                    className="btn poppins-semiBold rounded-pill orange-outline-btn btn-block"
                    to={"/"}
                  >
                    BOOK NOW
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </MasterLayout>
  );
};

export default PostDetails;
